<div class="table-header-components-wrapper">
  @if (sortable) {
    <span
      class="label"
      [class.sortable]="sort !== undefined"
      (click)="toggleSortDirection()"
      matTooltip="{{ sort !== undefined ? ('commons.grid.sort' | translate) + ' ' + (label | translate) : null }}"
    >{{ label | translate }}</span>
    @if (sort) {
      <button mat-icon-button class="direction fa-icon" matTooltip="{{ sort }}" (click)="toggleSortDirection()">
        @if (type === 'alpha') {
          @if (sort === 'asc') {
            <em class="fa fa-sort-alpha-down"></em>
          }
          @if (sort === 'desc') {
            <em class="fa fa-sort-alpha-down-alt"></em>
          }
        }
        @if (type === 'numeric') {
          @if (sort === 'asc') {
            <em class="fa fa-sort-numeric-down"></em>
          }
          @if (sort === 'desc') {
            <em class="fa fa-sort-numeric-down-alt"></em>
          }
        }
        @if (type === 'size') {
          @if (sort === 'asc') {
            <em class="fa fa-sort-size-down-alt"></em>
          }
          @if (sort === 'desc') {
            <em class="fa fa-sort-size-down"></em>
          }
        }
      </button>
    }
  }
  @if (!sortable) {
    <span class="label">{{ label | translate }}</span>
  }
</div>
